export const OFFER_MODEL = "offer";
import { OFFER_GROUPS, COMMENTS } from "@/models/relationships";

const offerModel = {
  salary: 0,
  status: "",
  startDate: "",
  unspentCriminalConvictions: "",
  application: {
    jsonApi: "hasOne",
    type: "applications"
  },
  offerGroups: {
    jsonApi: "hasMany",
    type: OFFER_GROUPS
  },
  contracts: {
    jsonApi: "hasMany",
    type: "offer-contracts"
  },
  comments: {
    jsonApi: "hasMany",
    type: COMMENTS
  },
  conversations: {
    jsonApi: "hasOne",
    type: "conversations"
  },
  applications: {
    jsonApi: "hasMany",
    type: "applications"
  }
};

export const offerActions = [
  "complete",
  "request-references",
  "withdraw",
  "approve",
  "submit-for-approval",
  "reject",
  "accept"
];

export default offerModel;
